import React, { useState } from 'react';
import { Field, reduxForm, formValues, SubmissionError } from 'redux-form';
import { useSelector, connect } from 'react-redux'
import Loader from 'Loader.js';
import { sendParagonexAuthorizationData } from 'integrationActions.js';
import classNames from 'classnames';
import HintIcon from 'hint_icon.svg';
import ReactTooltip from 'react-tooltip';
import Box from 'react-styled-box';
import { translation } from 'helpers/utilsHelper.js';
import ParagonexTransfer from 'ParagonexTransfer.js';
import { NotLogged } from 'global/styles/styles.js';
import { getIsLogged } from 'authSelector.js';
import { CSSTransition } from 'react-transition-group';

import S from 'StyledParagonex';

// Validation
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';


const validate = values => {
    const errors = validation(values, validators.PARAGONEX_AUTHORIZATION);
    return errors;
};

const Hint = ({fieldName}) => {
    return (
        <S.Hint>
            <S.HintIcon data-tip data-for={`hint-tooltip-${fieldName}`} dangerouslySetInnerHTML={{__html: HintIcon}} />
            <ReactTooltip id={`hint-tooltip-${fieldName}`} type="light">
                {translation(`paragonex_authorization_${fieldName}Hint`)}
            </ReactTooltip>
        </S.Hint>
    );
};

const ParagonexIframe = ({iframeUrl}) => {

    return (iframeUrl) ? 
        (
            <S.ParagonexIframe
                src={iframeUrl}
                title='ParagonexIframe'
                frameBorder={0}
                scrolling='no'
            />
        )
        : 
        null;
  }

let AuthorizationMethodChooser = ({ authorizationMethod, change }) => {
    return (
        <S.AuthorizationMethodChooser>
            <S.AuthorizationMethod isActive={(authorizationMethod == 'login')}
                onClick={change.bind(null, 'authorizationMethod', 'login')}>
                {translation('paragonex_loginMethod')}
            </S.AuthorizationMethod>
            <S.AuthorizationMethod isActive={(authorizationMethod == 'register')}
                onClick={change.bind(null, 'authorizationMethod', 'register')}>
                {translation('paragonex_registerMethod')}
            </S.AuthorizationMethod>
        </S.AuthorizationMethodChooser>
    )
};
AuthorizationMethodChooser = formValues('authorizationMethod')(AuthorizationMethodChooser);

let AuthorizationMethodFields = ({ authorizationMethod }) => {

    return (authorizationMethod == 'login') ?
        (
            <S.AuthorizationMethodFields>
                <Field
                    name="password"
                    type="text"
                    component={renderField}
                    label={translation('paragonex_password')}
                />
            </S.AuthorizationMethodFields>
        )
        :
        (

            <S.AuthorizationMethodFields>
                <Field
                    name="password"
                    type="text"
                    component={renderField}
                    label={translation('paragonex_password')}
                />

                <Field
                    name="confirmPassword"
                    type="text"
                    component={renderField}
                    label={translation('account_registerForm_confirmPassword')}
                />
            </S.AuthorizationMethodFields>

        )

};
AuthorizationMethodFields = formValues('authorizationMethod')(AuthorizationMethodFields);

const renderField = ({
    input,
    label,
    type,
    disabled,
    meta: { touched, error, warning, valid, submitFailed }
}) => {

    const isDisabled = (typeof disabled != 'undefined') ? disabled : false;
    const inputClass = classNames({
        'has-error': ((touched || submitFailed) && error),
        'is-valid': ((touched || submitFailed) && valid)
    });

    return (
        <S.Row>
            <S.InputWrapper>

                {['password'].includes(input.name) && <Hint fieldName={input.name} />}
                
                <S.Label>{label}</S.Label>
                <S.Input {...input} type={type} required="required" autocomplete="false" className={inputClass} disabled={isDisabled} />

                {(touched || submitFailed) && ((error && <S.Error>{translation(`paragonex__login_${error[0]}`)}</S.Error>) || (warning &&
                    <S.Error>{warning}</S.Error>))}

            </S.InputWrapper>
        </S.Row>
    )
};

/* To be deleted post go-live */
const isProd = Number(process.env.IS_PROD)

const DARK_LIVE_IDS = [
    1001 /* support_test */,
    48847 /* u4ma */,
    372392 /* stephen_echefu */,
    291265 /* echepops */
]
/* end of part to be deleted */

let Paragonex = ({ change, handleSubmit, submitting, error, invalid, pristine, user }) => {
    /* To be deleted post go-live */
    if (isProd && !DARK_LIVE_IDS.includes(user?.userId)) return null
    /* end of part to be deleted */

    const [tradeRoomUrl, setTradeRoomUrl] = useState(null);
    const [transferSession, setTransferSession] = useState(null);
    const [toggleTransferForm, setToggleTransferForm] = useState(false);

    const sendData = async (formData, dispatch) => {

        const {authorizationMethod} = formData; 
        const postData = {
            registration: authorizationMethod == 'register' ? true : false,
            password: formData.password
        }
    
        try {
            const {tradeRoomUrl, transferSession} = await dispatch(sendParagonexAuthorizationData(postData));
            setTradeRoomUrl(tradeRoomUrl);
            setTransferSession(transferSession);

        } catch (error) {
            throw new SubmissionError({_error: String(error.message)});
        }
    }

    if (!useSelector(getIsLogged)) {
        return <NotLogged>{translation('paragonex_notLogged')}</NotLogged>
    }

    return (!tradeRoomUrl) ? 
        (
            <S.ParagonexForm onSubmit={handleSubmit(sendData)} autoComplete="off" noValidate>
                {submitting && (<S.Cover><Loader color="#F05A22" /></S.Cover>)}

                <S.Body>
                    <Box flexDirection="column">
                        <AuthorizationMethodChooser change={change} />
                        <AuthorizationMethodFields />
                        {error && <S.SubmissionError>{error}</S.SubmissionError>}
                        <S.SubmitBtn type="submit" disabled={invalid || submitting || pristine}> 
                            {translation('paragonex_authorization')}
                        </S.SubmitBtn>
                    </Box>
                </S.Body>

            </S.ParagonexForm>
        ) 
        :
        (
            <S.ParagonexTradeRoom>
                <ParagonexIframe iframeUrl={tradeRoomUrl}/>
                <S.ToggleTransferForm onClick={() => setToggleTransferForm(!toggleTransferForm)} toggleTransferForm={toggleTransferForm}>
                    <span>
                        {translation('paragonex_toggleTransferForm')}
                    </span>
                    <span></span>
                </S.ToggleTransferForm>
                {transferSession && 
                    <CSSTransition
                        in={toggleTransferForm}
                        timeout={500}
                        classNames="paragonexTransfer-transition"
                        unmountOnExit
                        apper>
                        <ParagonexTransfer transferSession={transferSession} /> 
                    </CSSTransition>}
            </S.ParagonexTradeRoom>
        )
}

const mapStateToProps = ({ Auth: { user } }) => {

    return {
        user,
        initialValues: {
            authorizationMethod: 'login'
        }
    }
}

Paragonex = reduxForm({
    form: 'paragonexForm',
    validate,
    destroyOnUnmount: false,
})(Paragonex)

export default connect(mapStateToProps)(Paragonex);

